"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/ItemsList.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactwaypoint = require('react-waypoint');




var _store = require('web/store');

var _Item = require('./Item'); var _Item2 = _interopRequireDefault(_Item);














// The chat open in the right pane, from the route (/inbox/:blobjectKey/...).
// Read from history directly so a navigation re-renders the list, and only
// the two rows whose selection changed re-render under it.
const OPEN_CHAT_PATH = /^\/inbox\/([^/]+)/
const subscribeToHistory = (onChange) => _store.history.listen(onChange)
const getOpenBlobjectKey = () =>
  _nullishCoalesce(_optionalChain([OPEN_CHAT_PATH, 'access', _ => _.exec, 'call', _2 => _2(_store.history.location.pathname), 'optionalAccess', _3 => _3[1]]), () => ( null))
 const useOpenBlobjectKey = () => _react.useSyncExternalStore.call(void 0, subscribeToHistory, getOpenBlobjectKey); exports.useOpenBlobjectKey = useOpenBlobjectKey

const List = ({
  activeFilter,
  hasMore,
  onLoadMore,
  blobjectKeys,
  isBlobjectBeingArchived,
  onToggleBlobjectArchived,
  isSelectionHidden = false,
  onMarkUnread,
  onTogglePinned,
}) => {
  const routeBlobjectKey = exports.useOpenBlobjectKey.call(void 0, )
  const openBlobjectKey = isSelectionHidden ? null : routeBlobjectKey

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  blobjectKeys.map(
        (blobjectKey, idx) => (
          _react2.default.createElement(_Item2.default, {
            key: blobjectKey,
            blobjectKey: blobjectKey,
            hasTooltip: idx === 0,
            isSelected: blobjectKey === openBlobjectKey,
            activeFilter: activeFilter,
            isBeingArchived: isBlobjectBeingArchived(blobjectKey),
            onToggleArchived: onToggleBlobjectArchived,
            onMarkUnread: onMarkUnread,
            onTogglePinned: onTogglePinned, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
          )
        ))
      
      ,  hasMore && (
        _react2.default.createElement(_reactwaypoint.Waypoint, {
          bottomOffset: -100,
          // Left inline on purpose (TM-559): react-waypoint is a PureComponent
          // that re-checks its position on every prop change, and the next page
          // loads through that re-check when rows are removed without a scroll.
          // oxlint-disable-next-line react-perf/jsx-no-new-function-as-prop -- intentional, see above
          onEnter: () => onLoadMore(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
        )
      )
    )
  )
}

exports. default = List
